import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    border: `2px solid ${theme.palette.custom.grey}`,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
  },
  itemContainer: {
    marginRight: 100,
  },
  button: {
    backgroundColor: theme.palette.custom.white,
    border: '0px',
    cursor: 'pointer',
  },
}))

export default useStyles
